import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDEKoXhB5jKQu92N91OcWEK0YqN1Gcajd0",
  authDomain: "xervix-ia.firebaseapp.com",
  projectId: "xervix-ia",
  storageBucket: "xervix-ia.firebasestorage.app",
  messagingSenderId: "925109206384",
  appId: "1:925109206384:web:7c387f1d5ff8482637e3b5",
  measurementId: "G-N5LDSS6EC6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, analytics, auth, storage };
